<template>
  <div class="liu">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="handleGoBackClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :class="hasUpgradeBtnClass" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 提示行 -->
      <!-- 如果有tips提示信息，此div样式要用class="tips-box" -->
      <div />
      <!-- 空页 -->
      <div v-if="isShowEmptyData"></div>
      <!-- 列表信息 -->
      <div class="agent-list" v-if="isShowListData">
        <div class="agent-info-box" v-for="(item, index) in myData.list" :key="index" @click="jumpDetail(item)">
          <div class="agent-info">
            <div class="agent-check" v-if="canUpgradeAgent" @click.stop="onSelectedCheckClick(item)">
              <svg-icon :icon-class="selectedCheckSvgPath(item)" class-name="cur-icon"></svg-icon>
            </div>
            <img :src="item.logoUrl || require('../assets/image_default_agent@3x.png')" width="44" height="44" />
            <span class="agent-name" :class="getAgentNameClass()">{{ item.name }}</span>
            <span class="agent-status" :class="getAgentStatusClass(item.status)">{{ item.statusMsg }}</span>
            <span class="agent-date">{{ item.insertDate }}</span>
          </div>
          <div class="agent-eye" @click.stop="onAgentDetailEyeClick(item)">
            <svg-icon :icon-class="item.dataShow ? svg.eyeOpen : svg.eyeClose" class-name="cur-icon" />
          </div>
          <div class="agent-detail pd" v-for="(i, idx) in item.moneyBase" :key="idx">
            <div class="item-cell">
              <div class="cell-top-a">{{ i.value }}</div>
              <div class="cell-bottom">{{ i.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../assets/bitmap_agent@3x.png" width="60%" />
          <div class="title-4">
            {{ emptyStartDate + " - " + emptyEndDate + " 暂无新增商户" }}
            <span v-if="myData.inviteUser" @click="handleGoInviteClick">邀请商户</span>
          </div>
          <div class="title-4"> 点击右上角 <span @click="visible.search = true">更多</span> 查看更多商户信息 </div>
        </div>
      </div>
      <!-- 右下角圆形新增商户 -->
      <div class="invite-box" v-if="isShowListData && myData.inviteUser && !canUpgradeAgent" @click="handleGoInviteClick">
        新增<br />商户
      </div>
      <!-- 升代理、新增商户按钮 -->
      <div class="more-button" v-if="canUpgradeAgent && isShowListData">
        <span class="blue" :disabled="!disabled.hasSelectedCustomer" @click="onUpgradeAgentClick">升代理</span>
        <span class="blue" :disabled="!myData.inviteUser" @click="handleGoInviteClick">新增商户</span>
      </div>
    </div>
    <!-- 筛选页面 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 商户名 -->
          <div class="content-box">
            <div>
              <span>商户名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="search.user.selected" placeholder="请选择商户名称或手机号" readonly @click="handleUserClickEvent" />
              <img v-show="!search.user.empty" :src="require('@/assets/clear.png')" alt @click="handleClearSearchUserClick" />
            </div>
          </div>
          <!-- 代理商名 -->
          <div class="content-box">
            <div>
              <span>代理商名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="search.agent.selected" placeholder="请选择代理商名称或手机号" readonly @click="handleAgentClickEvent" />
              <img v-show="!search.agent.empty" :src="require('@/assets/clear.png')" alt @click="handleClearSearchAgentClick" />
            </div>
          </div>
          <!-- 状态 -->
          <div class="content-box">
            <div>
              <span>状态</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.type === item.value }" v-for="(item, index) in search.type.list" :key="index" @click="myParam.type = item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 达标状态 -->
          <div class="content-box" v-if="isShowItemBySaleTask && isShowByType">
            <div>
              <span>达标状态</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.reachType === item.value }" v-for="(item, index) in search.reachType.list" :key="index" @click="myParam.reachType = item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 销售政策阶段id -->
          <div v-if="isShowItemBySaleTask && isShowByType">
            <div class="content-box" v-for="(item, index) in this.search.agentSaleTask.list" :key="index">
              <div>
                <span>{{ item.saleTplName }}</span>
              </div>
              <div class="clearfix">
                <span type="default" class="star" :class="{ 'select-star': i.selected === true }" v-for="(i, idx) in item.agentSaleTpStage" :key="idx" @click="handleSaleTaskItemClick(i)">
                  {{ i.stageName }}
                </span>
              </div>
            </div>
          </div>
          <!-- 交易额 -->
          <div class="content-box">
            <div>
              <span>交易额</span>
            </div>
            <div>
              <input type="number" class="name-mobile w38" v-model="search.money.min" placeholder="最小金额" @blur="handleMinMoneyBlur" />
              -
              <input type="number" class="name-mobile w38" v-model="search.money.max" placeholder="最大金额" @blur="handleMaxMoneyBlur" />
            </div>
          </div>
          <!-- 注册时间 -->
          <div class="content-box">
            <div>
              <span>注册时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="handleDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="handleDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="handleSearchBtnCancelClick">取消</span>
          <span class="blue" @click="handleSearchBtnSubmitClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 商户名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.user" position="right" :modal="false">
      <mt-header fixed title="选择商户" class="title2">
        <mt-button slot="left" icon="back" @click="visible.user = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <mt-search v-model="search.user.key" @keyup.enter.native="handleUserListSearch" cancel-text="取消" placeholder="输入商户姓名或手机号" :show="true">
            <div class="result-list">
              <div class="list-row">
                <div class="list-item" v-for="(item, index) in search.user.list" :key="index" @click="handleSelectedUserClick(item)">
                  <span>{{ item.userName + " " + item.mobile }}</span>
                </div>
              </div>
            </div>
          </mt-search>
        </form>
      </div>
    </mt-popup>
    <!-- 代理商名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.agent" position="right" :modal="false">
      <mt-header fixed title="选择代理商" class="title2">
        <mt-button slot="left" icon="back" @click="visible.agent = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <mt-search v-model="search.agent.key" @keyup.enter.native="handleAgentListSearch" cancel-text="取消" placeholder="输入代理商姓名或手机号" :show="true">
            <div class="result-list">
              <div class="list-row">
                <div class="list-item" v-for="(item, index) in search.agent.list" :key="index" @click="handleSelectedAgentClick(item)">
                  <span>{{ item.name + " " + item.mobile }}</span>
                </div>
              </div>
            </div>
          </mt-search>
        </form>
      </div>
    </mt-popup>
    <!-- 日期选择 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="handleDatePickerConfirm"></mt-datetime-picker>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT,PUBLIC_SYSTEM_FLAG */

import { Indicator, MessageBox } from 'mint-ui';
import { GetUserStatus } from '@/api/user';
import { SucceedHandle, SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetMyUserListV2, GetMyUserMoneyListV2, GetAgentAllSale, UserUpdateToAgent, GetUserListBox, GetAgentListBox, DateBase } from '@/api/agent';
import { formatDate, multiply } from '@/utils/utils';
import { CusToast } from '@/utils/CustomToast';
export default {
  name: 'Customer',
  data() {
    return {
      title: '我的商户',
      product: PUBLIC_PRODUCT,
      // 商户
      myData: {
        list: [],
        total: -1,
        inviteUser: false,
        scrollDisabled: true,
        selectedItem: null,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 5,
        findAllTime: false,
        startDate: '',
        endDate: '',
        userId: '',
        productAgentId: '',
        agentSaleTaskId: [],
        reachType: -1,
        type: 0,
        minMoney: null,
        maxMoney: null,
        queryType: 1,
      },
      // 查询数据
      search: {
        // 状态
        type: {
          list: [
            { name: '全部', value: 0 },
            { name: '未认证', value: 1 },
            { name: '已认证', value: 2 },
            { name: '已实名', value: 3 },
          ],
        },
        // 达标状态
        reachType: {
          list: [
            { name: '全部', value: -1 },
            { name: '未达标', value: 0 },
            { name: '已达标', value: 1 },
          ],
        },
        // 销售政策阶段
        agentSaleTask: {
          list: [],
        },
        // 商户名
        user: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 代理商名
        agent: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 金额
        money: {
          min: null,
          max: null,
        },
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
        user: false,
        agent: false,
      },
      // 禁用开关
      disabled: {
        hasSelectedCustomer: false,
      },
      svg: {
        eyeOpen: 'show_money',
        eyeClose: 'hide_money',
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'customerdetail') {
      this.$store.commit('setCache', 'Customer');
    } else {
      this.$store.commit('delCache', 'Customer');
    }
    next();
  },
  mounted() {
    this.initData();
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    isShowByType() {
      return this.myParam.type === 0 || this.myParam.type === 3;
    },
    isShowItemBySaleTask() {
      return this.search.agentSaleTask.list && this.search.agentSaleTask.list.length > 0;
    },
    selectedCheckSvgPath() {
      return item => (item.selected ? 'selected_coupons' : 'unselected_coupons');
    },
    hasUpgradeBtnClass() {
      if (this.product && this.product.toLowerCase().trim() === 'xhgj') return 'pd-btm-45';
      return '';
    },
    canUpgradeAgent() {
      if (this.product && this.product.toLowerCase().trim() === 'xhgj') return true;
      return false;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getUserStatus(() => {
        this.getAgentSaleTask(() => {
          this.getDateBase(() => {
            this.getMyData();
          });
        });
      });
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      this.myParam.agentSaleTaskId = this.getSelectedSaleTaskIdArr();
      this.myParam.minMoney = this.search.money.min ? multiply(this.search.money.min, 100) : null;
      this.myParam.maxMoney = this.search.money.max ? multiply(this.search.money.max, 100) : null;
      GetMyUserListV2(this.myParam)
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.total = res.total;
            this.myData.list.push(...res.data.list);
            // 循环添加一个selected属性、dataShow属性、moneyBase对象
            this.myData.list.forEach(item => {
              item.selected = false;
              item.dataShow = false;
              item.moneyBase = [
                { name: '今日交易额(元)', value: '****' },
                { name: '本月交易额(元)', value: '****' },
              ];
            });
            // 通过记录条数list.length和数据总数total判断是否查询出所有数据
            // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
            if (this.myData.list.length < this.myData.total) {
              this.myData.scrollDisabled = false;
            }
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 获取用户状态
    getUserStatus(callback) {
      GetUserStatus()
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.inviteUser = res.data.inviteUser;
            callback && callback();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 获取销售政策列表
    getAgentSaleTask(callback) {
      GetAgentAllSale({ type: 2 })
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.search.agentSaleTask.list = res.rows;
            // 整理销售政策列表
            this.search.agentSaleTask.list.forEach(element => {
              // 1.每一项销售政策的每一个子项都手动添加一个"选中"状态，默认为不选中
              for (const i of element.agentSaleTpStage) {
                i.selected = false;
              }
              // 2.每一项销售政策都添加一个“全部”选项
              const obj = {
                selected: false,
                agentSaleTaskId: -1,
                money: 0,
                reach: '',
                stageName: '全部',
              };
              element.agentSaleTpStage.splice(0, 0, obj);
            });
            // 3.默认选中第一项销售政策的“全部”选项
            if (this.search.agentSaleTask.list && this.search.agentSaleTask.list.length > 0) {
              if (this.search.agentSaleTask.list[0].agentSaleTpStage && this.search.agentSaleTask.list[0].agentSaleTpStage.length > 0) {
                this.search.agentSaleTask.list[0].agentSaleTpStage[0].selected = true;
              }
            }
            callback && callback();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          this.search.agentSaleTask.list = [];
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 代理商列表日期查询条件
    getDateBase(callback) {
      DateBase({ interfaceName: '/app/Agent/GetMyUserListV2' })
        .then(res => {
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.picker.startDateBase = res.data.startDate.split(' ')[0];
            this.picker.endDateBase = res.data.endDate.split(' ')[0];
            this.picker.startDateText = this.picker.startDateBase;
            this.picker.endDateText = this.picker.endDateBase;
            callback && callback();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 跳页
    jumpDetail(item) {
      this.$router.push({
        path: '/customerdetail',
        query: { userid: item.userId, status: item.status, statusMsg: item.statusMsg },
      });
    },
    // 日期确定事件
    handleDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // 单击日期事件
    handleDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询搜索单击取消事件
    handleSearchBtnCancelClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 查询搜索单击确定事件
    handleSearchBtnSubmitClick() {
      // 1.验证金额
      if (!this.verifyMinMoney()) return;
      if (!this.verifyMaxMoney()) return;
      // 2.滚动条置顶
      window.scrollTo(0, 0);
      // 3.关闭查询窗口
      this.visible.search = false;
      // 4.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 5.重置列表数据
      this.myData.list = [];
      // 6.重置翻页页数
      this.myParam.pageNum = 1;
      // 7.重置总数
      this.myData.total = -1;
      // 8. 加载数据
      this.getMyData();
    },
    // 升代理事件
    onUpgradeAgentClick() {
      if (this.myData.selectedItem.status === 3) {
        MessageBox({
          title: '',
          message: '确定将该商户升级为代理商？',
          showCancelButton: true,
          confirmButtonText: '升级',
          cancelButtonText: '取消',
          confirmButtonHighlight: true,
          confirmButtonClass: 'confirm-btn',
        }).then(action => {
          // 点击确定
          if (action === 'confirm') {
            Indicator.open();
            const userId = this.myData.selectedItem.userId;
            UserUpdateToAgent({ userId })
              .then(res => {
                SucceedHandle2(
                  res.code,
                  res.msg,
                  () => {
                    Indicator.close();
                    // 提示成功
                    CusToast('升级操作成功');
                    // 滚动条置顶
                    window.scrollTo(0, 0);
                    // 打开滚动刷新
                    this.myData.scrollDisabled = true;
                    // 重置列表数据
                    this.myData.list = [];
                    // 重置翻页页数
                    this.myParam.pageNum = 1;
                    // 重置总数
                    this.myData.total = -1;
                    // 加载数据
                    this.getMyData();
                  },
                  (code, msg) => {
                    Indicator.close();
                    msg && CusToast(msg);
                  }
                );
              })
              .catch(err => {
                Indicator.close();
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          }
        });
      }
    },
    // 返回事件
    handleGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 跳转邀请商户
    handleGoInviteClick() {
      window.location.href = 'invite://android';
    },
    // 筛选窗口商户名称点击事件
    handleUserClickEvent() {
      this.getUserListBox('', () => {
        this.visible.user = true;
        this.search.user.key = '';
      });
    },
    // 商户名称列表商户名称查询事件
    handleUserListSearch() {
      this.getUserListBox(this.search.user.key);
    },
    // 交互后返回商户列表
    getUserListBox(nameOrMobile, callback = null) {
      Indicator.open();
      GetUserListBox({ nameOrMobile })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.search.user.list = res.rows;
            document.activeElement.blur();
            callback && callback();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 商户列表选中商户名称事件
    handleSelectedUserClick(item) {
      this.search.user.selected = `${item.userName} ${item.mobile}`;
      this.myParam.userId = item.userId;
      this.search.user.empty = false;
      this.visible.user = false;
    },
    // 筛选窗口代理商名称点击事件
    handleAgentClickEvent() {
      this.getAgentListBox('', () => {
        this.visible.agent = true;
        this.search.agent.key = '';
      });
    },
    // 代理商名称列表商户名称查询事件
    handleAgentListSearch() {
      this.getAgentListBox(this.search.agent.key);
    },
    // 交互后返回代理商列表
    getAgentListBox(nameOrMobile, callback = null) {
      Indicator.open();
      const agentFindType = 1;
      GetAgentListBox({ agentFindType, nameOrMobile })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.search.agent.list = res.rows;
            document.activeElement.blur();
            callback && callback();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 代理商列表选中商户名称事件
    handleSelectedAgentClick(item) {
      this.search.agent.selected = `${item.name} ${item.mobile}`;
      this.myParam.productAgentId = item.productAgentId;
      this.search.agent.empty = false;
      this.visible.agent = false;
    },
    // 筛选窗口销售政策点击事件
    handleSaleTaskItemClick(i) {
      // 全部销售政策置成未选中
      this.search.agentSaleTask.list.forEach(element => {
        element.agentSaleTpStage.forEach(item => (item.selected = false));
      });
      // 当前的销售政策置成选中
      i.selected = true;
      this.$forceUpdate();
    },
    // 返回选中的销售政策id的集合
    getSelectedSaleTaskIdArr() {
      // 循环遍历销售政策数组
      // 获取手动添加的名称为“全部”选项
      // 判断此“全部”选项的是否被选中
      // 如果结果为选中：则将此行出除去”全部“选项外其它的所有销售政策id存入result数据集
      // 如果结果为未选中：则只选取此行中状态为选中的销售政策id存入result数据集
      const result = [];
      this.search.agentSaleTask.list.forEach(element => {
        const all = element.agentSaleTpStage.filter(item => item.agentSaleTaskId === -1)[0];
        if (all.selected) {
          element.agentSaleTpStage.forEach(task => task.agentSaleTaskId !== -1 && result.push(task.agentSaleTaskId));
        } else {
          const selected = element.agentSaleTpStage.filter(item => item.selected === true)[0];
          selected && result.push(selected.agentSaleTaskId);
        }
      });
      return result;
    },
    // 返回商户姓名的样式名称
    getAgentNameClass() {
      return PUBLIC_SYSTEM_FLAG === 'android' ? 'android' : 'ios';
    },
    // 返回用户状态的样式名称
    getAgentStatusClass(val) {
      return `status${val}`;
    },
    // 清空筛选框中用户名称的事件
    handleClearSearchUserClick() {
      this.search.user.selected = '';
      this.myParam.userId = '';
      this.search.user.empty = true;
    },
    // 清空筛选框中代理商名称的事件
    handleClearSearchAgentClick() {
      this.search.agent.selected = '';
      this.myParam.productAgentId = '';
      this.search.agent.empty = true;
    },
    // 验证最小金额
    verifyMinMoney() {
      const min = parseFloat(this.search.money.min);
      const max = parseFloat(this.search.money.max);
      if (min > max) {
        MessageBox({
          title: '提示',
          message: '交易额的最小金额不能大于最大金额',
        });
        return false;
      }
      return true;
    },
    // 验证最大金额
    verifyMaxMoney() {
      const min = parseFloat(this.search.money.min);
      const max = parseFloat(this.search.money.max);
      if (min > max) {
        MessageBox({
          title: '提示',
          message: '交易额的最大金额不能小于最小金额',
        });
        return false;
      }
      return true;
    },
    // 最小金额输入框失焦点事件
    handleMinMoneyBlur() {
      this.verifyMinMoney();
    },
    // 最大金额输入框失焦点事件
    handleMaxMoneyBlur() {
      this.verifyMaxMoney();
    },
    // 置空所有筛选窗口数据
    clearSearchData() {
      this.search.user.key = '';
      this.search.user.selected = '';
      this.search.user.empty = true;
      this.search.agent.key = '';
      this.search.agent.selected = '';
      this.search.agent.empty = true;
      this.myParam.type = 0;
      this.myParam.reachType = -1;
      this.search.money.min = null;
      this.search.money.max = null;
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
      // 全部销售政策置成未选中
      this.search.agentSaleTask.list.forEach(element => {
        element.agentSaleTpStage.forEach(item => (item.selected = false));
      });
      // 默认选中第一项销售政策的“全部”选项
      if (this.search.agentSaleTask.list && this.search.agentSaleTask.list.length > 0) {
        if (this.search.agentSaleTask.list[0].agentSaleTpStage && this.search.agentSaleTask.list[0].agentSaleTpStage.length > 0) {
          this.search.agentSaleTask.list[0].agentSaleTpStage[0].selected = true;
        }
      }
    },
    // 选中商户的checkbox的click事件
    onSelectedCheckClick(item) {
      // 勾选未认证或已认证时给出提示 已实名商户才能升级为代理商
      if (item.status !== 3) {
        CusToast('已实名商户才能升级为代理商');
        return;
      }
      // 首先存储选中的item
      this.myData.selectedItem = item;
      // 首先将列表中selected全部置false
      this.myData.list.forEach(row => (row.selected = false));
      // 再设置当前商户的选中状态
      this.myData.selectedItem.selected = !this.myData.selectedItem.selected;
      // 循环全部数据集判断是否有选中的商户
      // 有，则让selectedCount计数器加1，反之则不加
      let selectedCount = 0;
      this.myData.list.forEach(row => row.selected && (selectedCount += 1));
      // 判断计数器
      // 如果大于0，则证明有选中的商户，让”升代理“按钮可用
      // 反之，则证明没有选中的商户，让“升代理”按钮不可用
      this.disabled.hasSelectedCustomer = selectedCount > 0;
      // 重新渲染组件
      this.$forceUpdate();
    },
    // 单击眼睛
    onAgentDetailEyeClick(item) {
      this.$nextTick(() => {
        if (item.dataShow) {
          item.dataShow = false;
          item.moneyBase = [
            { name: '今日交易额(元)', value: '****' },
            { name: '本月交易额(元)', value: '****' },
          ];
          this.$forceUpdate();
        } else {
          Indicator.open();
          GetMyUserMoneyListV2({ userId: item.userId })
            .then(res => {
              Indicator.close();
              const msg = SucceedHandle(res.code, res.msg, () => {
                item.dataShow = true;
                item.moneyBase = res.rows;
                this.$forceUpdate();
              });
              msg && CusToast(msg);
            })
            .catch(err => {
              Indicator.close();
              const msg = NotSucceedHandle(err.message);
              msg && CusToast(msg);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.pd {
  padding-top: 0;
  padding-bottom: 0.3rem;
}
</style>
